import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useCompare } from "../context/CompareContext";
import { IMAGE_COMING_SOON } from "../imageComingSoon";
import "./CompareBar.css";

// Mounted once at the Layout level in App.js so it persists across route
// changes -- same idea as the header cart icon always being reachable.
// Hidden on the compare page itself (redundant there) and whenever nothing
// is selected.
const CompareBar = () => {
  const { compareItems, removeFromCompare, clearCompare, limitMsg } = useCompare();
  const location = useLocation();
  const [showLimitMsg, setShowLimitMsg] = useState(false);

  useEffect(() => {
    if (!limitMsg) return;
    setShowLimitMsg(true);
    const t = window.setTimeout(() => setShowLimitMsg(false), 3500);
    return () => window.clearTimeout(t);
  }, [limitMsg]);

  if (compareItems.length === 0 || location.pathname === "/compare") return null;

  const canCompare = compareItems.length >= 2;

  return (
    <div className="compare-bar">
      {showLimitMsg && limitMsg && <div className="compare-bar-limit-msg">{limitMsg}</div>}
      <div className="compare-bar-inner">
        <div className="compare-bar-items">
          {compareItems.map((item) => (
            <div className="compare-bar-item" key={item.id} title={item.title}>
              <img
                src={item.image || IMAGE_COMING_SOON}
                alt={item.title}
                onError={(e) => { e.currentTarget.src = IMAGE_COMING_SOON; }}
              />
              <button
                type="button"
                className="compare-bar-item-remove"
                onClick={() => removeFromCompare(item.id)}
                aria-label={`Remove ${item.title} from compare`}
              >
                ✕
              </button>
            </div>
          ))}
        </div>

        <div className="compare-bar-actions">
          <span className="compare-bar-count">{compareItems.length} selected</span>
          <button type="button" className="compare-bar-clear" onClick={clearCompare}>
            Clear All
          </button>
          <Link
            to={canCompare ? "/compare" : "#"}
            className={`compare-bar-cta ${canCompare ? "" : "compare-bar-cta--disabled"}`}
            onClick={(e) => { if (!canCompare) e.preventDefault(); }}
            title={canCompare ? undefined : "Add at least 2 products to compare"}
          >
            Compare Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CompareBar;
